export class VisitContact {
  constructor(
    public lastName: string = '',
    public firstName: string = '',
    public email: string = '',
    public tel: string = ''
  ) {}
}
